const WALLET_STATUS = {
  CANCEL_METAMASK: 4001,
  NOT_EXISTED_NETWORK: 4902,
  ACTION_REJECTED: 'ACTION_REJECTED',
};

export default WALLET_STATUS;
